import { doc, getDoc } from 'firebase/firestore';
import { firestore } from 'services/firebase/client';
import type { GrowlersHero } from 'utils/types/Growler';

const COLLECTION = 'site_config';
const DOC_ID = 'growlers_hero';

/**
 * Busca a imagem do hero da landing /growlers.
 * Firestore: site_config/growlers_hero
 */
export async function getGrowlersHero(): Promise<GrowlersHero | null> {
  try {
    const ref = doc(firestore, COLLECTION, DOC_ID);
    const snapshot = await getDoc(ref);
    if (!snapshot.exists()) return null;
    const data = snapshot.data();
    if (!data?.image) return null;
    return {
      image: data.image,
      alt: data.alt ?? undefined,
    };
  } catch (error) {
    console.error('Erro ao buscar hero de growlers:', error);
    return null;
  }
}
